var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "outer" },
      [
        _c(
          "el-tabs",
          {
            attrs: { type: "border-card" },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "待发货", name: "1" } },
              [_vm.activeName === "1" ? _c("OrderList") : _vm._e()],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "导入发货", name: "2" } },
              [_vm.activeName === "2" ? _c("import-order") : _vm._e()],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "已发货", name: "3" } },
              [_vm.activeName === "3" ? _c("already-list") : _vm._e()],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }